import axios from "axios";
import { authClear } from "./service/util/authClear";
import { commonActions } from "./reducers/common";
import store from "./reducers/store";

const isDevelopment = process.env.NODE_ENV;
const token = localStorage.getItem("accessToken");

axios.defaults.baseURL = isDevelopment === "development" ? "/api" : process.env.REACT_APP_API_URL;
axios.defaults.withCredentials = true;
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

const setLogout = () => {
    store.dispatch(commonActions.setLogout());
    authClear();
    delete instance.defaults.headers.common['Authorization'];
    window.location.replace('/login');
}

const instance = axios.create({
    headers: {
        "Content-Type": "multipart/form-data",
        "Content-type": 'application/json',
    },
})
instance.interceptors.request.use(
    async config => {
        if (token) {
            config.headers.common['Authorization'] = `Bearer ${token}`;
        }
        return config;
    }
);
instance.interceptors.response.use((response) => response,
    async (error) => {
        if (token) {
            const {config, response: {status}} = error;
            if (status === 401 && !config?.sent) {
                try {
                    const originalConfig = config;
                    config.sent = true;
                    const refreshToken = localStorage.getItem('refreshToken');
                    const response = await instance.post('/renewToken', {}, {
                        headers: {
                            "Refresh": refreshToken
                        }
                    }).catch(err => {
                        setLogout();
                    })
                    const {data} = response;
                    if (data === "token_001") {
                        setLogout();
                    } else {
                        localStorage.removeItem('accessToken');
                        localStorage.setItem('accessToken', data);
                        originalConfig.headers["Authorization"] = `Bearer ${data}`;
                    }
                    return await instance.request(originalConfig);
                } catch (error) {
                    localStorage.removeItem('accessToken');
                }
                return Promise.reject(error);
            }
            return Promise.reject(error);
        }
    }
)

export default instance;